import { formatPrice } from '../services/formatPrice';

/**
 * Build the pay-what-you-want input placeholder for its three states:
 *   - a suggested price is set → "<Suggested> <amount>"  (e.g. "Suggested $50")
 *   - else a minimum is set    → "<Min.> <amount>"        (e.g. "Min. $10")
 *   - neither set              → the plain placeholder ("Enter amount" via
 *     payWhatYouWantPlaceholderText)
 *
 * The "Suggested" / "Min." words come from theme labels so they stay
 * translatable. `showPrice` is the merchant's "show minimum price" PWYW toggle —
 * when off, the min/suggested is never revealed and only the plain placeholder
 * shows. Amounts are in the smallest currency unit (cents), matching the price
 * subdoc. Shared by the single-price (CheckoutForm) and multi-price
 * (PayWhatYouWantPriceField) call-sites so both behave identically.
 */
export function getPwywPlaceholder({
  minAmount,
  suggestedAmount,
  currency,
  locale,
  labels = {},
  showPrice = true,
}) {
  const fallback = labels.payWhatYouWantPlaceholderText || 'Enter amount';
  if (!showPrice) return fallback;

  const suggested = Number(suggestedAmount) || 0;
  if (suggested > 0) {
    const prefix = labels.pwywSuggestedPricePlaceholderText || 'Suggested';
    return `${prefix} ${formatPrice({ amount: suggested, currency, locale })}`;
  }

  const min = Number(minAmount) || 0;
  if (min > 0) {
    const prefix = labels.pwywMinPricePlaceholderText || 'Min.';
    return `${prefix} ${formatPrice({ amount: min, currency, locale })}`;
  }

  return fallback;
}
